<template>
  <div
    @mouseenter="mouseEnter = openOrCloseDropDown()"
    @mouseleave="false"
    :class="[{ 'mouse-enter': mouseEnter, 'mouse-leave': !mouseEnter }]"
  >
    <dropdown-menu
      id="drop-menu"
      v-model="mouseEnter"
      :right="false"
      transition="translate-fade-down"
    >
      <md-button
        :md-ripple="false"
        data-v-step="0"
        md-elevation="0"
        class="md-icon-button dropdown-toggle menu-hamburguer"
        data-cy="tbHamburgerHeader"
        @click="keepOpen"
      >
        <md-icon>menu</md-icon>
      </md-button>
      <div slot="dropdown" class="my-drop">
        <p class="dropdown-section-title">MENU</p>
        <a
          class="dropdown-item"
          @click.prevent="openNewItemModal"
          data-cy="tbPostItem"
        >
          <md-icon id="header-icon">control_point</md-icon>
          <span>Post item</span>
        </a>
        <hr class="line-header" />
        <router-link
          class="dropdown-item"
          to="/s-app/feed"
          @click.native="close"
        >
          <md-icon id="header-icon">dynamic_feed</md-icon>
          <span>Feed</span>
        </router-link>
        <router-link
          class="dropdown-item"
          to="/s-app/my-groups"
          data-cy="linkMembershipPage"
          @click.native="close"
        >
          <md-icon id="header-icon">groups</md-icon>
          <span>Groups</span>
        </router-link>
        <router-link
          class="dropdown-item"
          to="/s-app/message-center"
          data-cy="tbLinkMessageCenter"
          @click.native="close"
        >
          <md-icon id="header-icon">question_answer</md-icon>
          <span>Message center</span>
        </router-link>
        <router-link
          class="dropdown-item"
          to="/s-app/item-activity"
          data-cy="tbActivityPageHeaderBtn"
          @click.native="close"
        >
          <md-icon id="header-icon">history</md-icon>
          <span>Item activity</span>
        </router-link>

        <!-- <router-link
          class="dropdown-item"
          to="/s-app/garage-sales"
          data-cy="tbGarageSaleHeaderBtn"
          @click.native="close"
        >
          <md-icon id="header-icon">warehouse</md-icon>
          <span>Garage sales</span>
        </router-link> -->

        <hr class="line-header" />
        <a
          class="dropdown-item"
          href="http://blog.swampum.com/"
          target="_blank"
          rel="noopener"
        >
          <md-icon id="header-icon">campaign</md-icon>
          <span>Blog</span>
        </a>
        <router-link
          class="dropdown-item"
          to="/s-app/help-center"
          data-cy="helpButtonMore"
          @click.native="close"
        >
          <md-icon id="header-icon">help_outline</md-icon>
          <span>Help center</span>
        </router-link>
        <router-link
          class="dropdown-item"
          to="/s-app/contact-us"
          data-cy="tbSupportButton"
          @click.native="close"
        >
          <md-icon id="header-icon">support_agent</md-icon>
          <span>Contact us</span>
        </router-link>
        <router-link
          class="dropdown-item"
          to="/s-app/terms-and-conditions"
          @click.native="close"
        >
          <md-icon id="header-icon">policy</md-icon>
          <span>Terms/conditions</span>
        </router-link>
      </div>
    </dropdown-menu>
  </div>
</template>

<script>
import DropdownMenu from "@innologica/vue-dropdown-menu";
import Global from "@/constants/Global";

export default {
  name: "SHeaderMenu",
  components: {
    DropdownMenu,
  },
  data() {
    return {
      mouseEnter: false,
      show: false,
    };
  },
  methods: {
    close() {
      this.$emit("changeKey");
    },
    keepOpen() {
      this.mouseEnter = false;
    },
    openNewItemModal() {
      $("#new-item").modal("show");
    },
    openInviteModal() {
      $("#share-with-friends").modal("show");
    },
    openOrCloseDropDown() {
      return !Global.checkDevice();
    },
  }
};
</script>

<style scoped>
.mouse-leave .md-button {
  background-color: white !important;
}
</style>

<style lang="scss" scoped>
.mouse-enter,
.mouse-leave {
  margin-right: 2px !important;
}
.md-icon-button.dropdown-toggle.menu-hamburguer {
  margin-right: 0;
}
.mouse-enter .md-button {
  background-color: $primary !important;
}
.md-button {
  border: 1px solid #e0e0e0;
  border-radius: 5px !important;
}
.md-icon-button {
  margin: 0;
}
.mouse-leave .md-icon {
  color: $primary !important;
}
.mouse-enter .md-icon {
  color: white !important;
}
</style>

<style lang="scss" scoped>
#header-icon {
  color: $header-icon-color !important;
  margin-top: -2px;
  margin-right: 0.4em;
}
.line-header {
  width: 70%;
  color: rgba(0, 0, 0, 0.2);
}
.dropdown-item {
  margin-top: 0.4rem;
  cursor: pointer;
}
</style>

<style lang="scss" scoped>
.my-drop::before {
  position: absolute;
  content: "";
  top: -1px;
  left: 10px;
  transform: translateY(-100%);
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 13px solid $primary;
}
</style>

<!-- Header drop menu style -->
<style lang="scss">
#drop-menu .show {
  width: 245px !important;
  margin-top: 0.95em;
  border: 1px solid $primary;
}
#drop-menu a {
  color: $black !important;
}
#drop-menu span {
  margin-left: 0.5rem;
  text-align: center;
  font-size: 14px;
  letter-spacing: 1.25px;
}
#drop-menu a:active {
  background-color: $primary;
}
.dropdown-section-title {
  font-size: 1.2rem;
  font-weight: bold;
  border-bottom: solid;
  border-color: $primary;
  padding-left: 10px;
}
.menu-hamburguer {
  height: 42px;
  width: 42px;
}
a,
a:hover {
  text-decoration: none !important;
}

@media screen and (min-width: 480px) {
  .menu-hamburguer {
    width: 46px;
    height: 46px;
  }
  .dropdown-item {
  margin: 2em 0em 1.5em 0em;
  font-size: 1.6em
  }

  hr.line-header{
      margin-bottom: 0.8em !important;
  }

}
@media screen and (min-width: 720px) {
  .menu-hamburguer {
    width: 50px;
    height: 50px;
  }
}


</style>
